export default __webpack_public_path__ + "static/media/automation.d8c382e7.jpg";